import { Injectable } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { TranslateService } from '@ngx-translate/core';
import { ONE_SECOND_MS } from '@coach-bot/shared/util';

const SNACKBAR_DURATION_MS = ONE_SECOND_MS * 8;

@Injectable()
export class NotificationsService {
  constructor(private snackBar: MatSnackBar, private translateService: TranslateService) {}

  showSnackBar(message: string, success: boolean, params?: Record<string, string>): void {
    this.snackBar.open(
      this.translateService.instant(message, params),
      this.translateService.instant('shared.actions.close'),
      {
        duration: SNACKBAR_DURATION_MS,
        verticalPosition: 'bottom',
        panelClass: success ? ['success-snackbar'] : ['alert-snackbar'],
      }
    );
  }
}
